const regionColors = [
  "#006AAD",
  "#0080AC",
  "#0095A3",
  "#00A897",
  "#64B98E",
  "#71B2C7",
  "#268177",
  "#7CD2C8",
  "#10617A",
  "#7AE9DE",
  "#22BF70",
]

const brandColors = [
  "#CDA23D",
  "#936F00",
  "#A6ABBD",
  "#424656",
  "#2C73D2",
  "#DAD2D8",
  "#04486A",
  "#3F898C",
  "#E19F44",
  "#9A2E23",
  "#8FA4F5",
  "#89C0F6",
  "#3F6487",
  "#F5D28F",
  "#D5D068",
  "#D17723",
]

const streamColors = ["#5E3C6E", "#8461B9", "#C687C5", "#D68B9E", "#F5C2CE"]

const restColors = [
  "#63A1D0",
  "#3576A7",
  "#00B8C0",
  "#0074E4",
  "#EDFF71",
  "#F1DB4B",
  "#BDC89B",
  "#EEEEFF",
  "#A7C6DA",
  "#942E88",
  "#DB5CA6",
  "#AC005D",
  "#F85959",
  "#FF9F68",
  "#9A69E1",
  "#47429D",
  "#F7B7F3",
  "#E27393",
  "#CD4545",
  "#F16821",
  "#F3A333",
  "#9564AE",
  "#28B8E9",
  "#81CD45",
  "#4B9D93",
  "#9A8E1F",
]

export const getPalette = (key: string) => {
  switch (key) {
    case "regions":
      return regionColors

    case "brands":
      return brandColors

    case "streams":
      return streamColors

    default:
      return restColors
  }
}
